import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import CloseIcon from '@/assets/svg/close.svg';

import { TagProps } from './types';

function Tag({ tag, onClick, isSelected = false }: TagProps) {
  return (
    <Component activeTag={isSelected} onClick={onClick}>
      <Label activeTag={isSelected}>{tag}</Label>
      <StyledCloseIcon activeTag={isSelected} />
    </Component>
  );
}

export default Tag;

const Label = styled.span<{ activeTag: boolean }>`
  font-size: 14px;
  line-height: 20px;
  transition: 0.3s;
  user-select: none;

  ${({ activeTag }) =>
    activeTag &&
    css`
      color: ${colors.white};
    `}
`;

const Component = styled.div<{ activeTag: boolean }>`
  position: relative;
  cursor: pointer;
  margin: 5px 5px 5px 0;
  padding: 5px 26px;
  background: ${colors.gray400};
  border-radius: 15px;
  transition: 0.3s;

  &:hover {
    background: ${colors.gray500};
  }

  ${({ activeTag }) =>
    activeTag &&
    css`
      padding: 5px 37px 5px 15px;
      background: ${colors.main};

      &:hover {
        ${Label} {
          text-decoration: line-through;
        }

        background: ${colors.main};
      }
    `}
`;

const StyledCloseIcon = styled(CloseIcon)<{ activeTag: boolean }>`
  display: none;
  position: absolute;
  width: 19px;
  height: 19px;
  fill: ${colors.white};
  transition: 0.3s;

  ${({ activeTag }) =>
    activeTag &&
    css`
      display: initial;
      top: 5px;
      right: 11px;
    `}
`;
